import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_SECONDARY_SALES_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const SecondarySalesReport = lazy(() =>
  import('../../../screens/SecondarySalesReport')
    .then(module => ({default: module.SecondarySalesReport})));

const SecondarySalesReportNavigation = [
  {
    path: ROUTE_SECONDARY_SALES_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SecondarySalesReport />
      </Suspense>
    ),
  },
];

export default SecondarySalesReportNavigation;
